import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBuilding,
  FaCode,
  FaShoppingCart,
  FaRocket,
  FaEnvelope,
  FaCrown,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EcommerceWebsiteDevelopmentCompanyInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-commerce Website Development Company in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Partner in Online Growth</Subheading>}
        heading={
          <Heading>
            Leading{" "}
            <span tw="text-primary-500">
              E-commerce Website Development Company
            </span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset is a premier e-commerce website development company
            in **Bur Dubai**, offering end-to-end solutions to build robust,
            scalable, and visually appealing online stores. We help businesses
            succeed in the digital marketplace with expert craftsmanship.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce development workspace
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Website design on screens
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce success concept
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Partner with Us"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Top E-commerce Development Company in Bur Dubai"
        description="We provide comprehensive services to elevate your online business."
        cards={[
          {
            icon: <FaBuilding color="#ff5464" size={40} />,
            title: "Full-Service Agency",
            description: "From design to deployment, we handle it all.",
          },
          {
            icon: <FaCode color="#ff5464" size={40} />,
            title: "Expert Developers",
            description: "Skilled team delivering cutting-edge solutions.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "E-commerce Focus",
            description:
              "Specialized in building high-converting online stores.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast & Reliable",
            description: "Quick delivery with uncompromised quality.",
          },
          {
            icon: <FaEnvelope color="#ff5464" size={40} />,
            title: "Ongoing Support",
            description: "Continuous assistance post-launch.",
          },
          {
            icon: <FaCrown color="#ff5464" size={40} />,
            title: "Trusted in Bur Dubai",
            description: "A proven leader in the local market.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Development Process for E-commerce Success"
        description={
          <Description>
            We follow a structured approach to deliver exceptional e-commerce
            websites:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your business and objectives.</li>
              <li>Design: Create user-friendly and attractive layouts.</li>
              <li>Development: Build a robust and scalable platform.</li>
              <li>Integration: Add payment gateways, shipping, and more.</li>
              <li>Testing: Ensure top performance and security.</li>
              <li>Launch & Maintenance: Deploy and support your growth.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Website development code
          "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team collaboration on digital project
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce process planning
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Results That Define Our Expertise"
        description="Our e-commerce development has transformed businesses in Bur Dubai."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Grew a retailer’s revenue by 200% with a new store.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Launch",
            description: "Deployed a custom site in just 3 weeks.",
          },
          {
            icon: <FaCrown color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "Rated 5 stars by 90% of our Bur Dubai clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready to Grow Your Online Presence?</Subheading>
        }
        heading="Work with Bur Dubai’s Top E-commerce Experts"
        description={
          <Description>
            Choose MilaajBrandset, the leading e-commerce website development
            company in Bur Dubai, to build a powerful online store that drives
            success. Let’s take your business to the next level.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Development team success
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline featuring Burj Khalifa
          "https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce shopping concept
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Today"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
